"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _MarginTransferAssetsFormComponent = _interopRequireDefault(require("./MarginTransferAssetsFormComponent"));
var _selectors = require("../../redux/margin/selectors");
var _transferActions = require("../../redux/actions/transferActions");
var _actions = require("../../redux/margin/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _initialReceiverAccou, _initialReceiverAccou2, _formObj$values$Produ3;
  var form = state.form,
    _state$user = state.user,
    accounts = _state$user.accounts,
    selectedAccountId = _state$user.selectedAccountId,
    _state$apexCore = state.apexCore,
    products = _state$apexCore.product.products,
    positions = _state$apexCore.position.positions,
    _state$margin = state.margin,
    UsableMarginNotional = _state$margin.accountInfo.UsableMarginValue,
    marginProducts = _state$margin.products.data,
    futuresProducts = state.futures.products;
  var formObj = form.marginTransferAssets || {
    values: {}
  };
  var marginAccount = (0, _selectors.marginAccountSelector)(state);
  var mainAccount = (0, _selectors.mainAccountSelector)(state);
  var initialSenderAccount = selectedAccountId ? accounts.find(function (account) {
    return account.AccountId === selectedAccountId;
  }) : mainAccount;
  var initialReceiverAccount;
  if (marginAccount && initialSenderAccount.AccountType !== marginAccount.AccountType) {
    // 3.7.1 If margin is enabled, by default the margin account must be selected.
    initialReceiverAccount = marginAccount;
  } else {
    // 3.7.2 If margin is not enabled and the trader has additional accounts, by default the first account in the list must be selected.
    initialReceiverAccount = accounts.find(function (account) {
      return account.AccountId !== initialSenderAccount.AccountId;
    }) || mainAccount;
  }
  var selectedReceiverAccount = accounts.find(function (account) {
    var _formObj$values$Recei;
    return account.AccountId === ((_formObj$values$Recei = formObj.values.ReceiverAccount) === null || _formObj$values$Recei === void 0 ? void 0 : _formObj$values$Recei.value);
  });
  var isMarginReceiver = (selectedReceiverAccount === null || selectedReceiverAccount === void 0 ? void 0 : selectedReceiverAccount.AccountType) === 'Margin';
  var isFuturesReceiver = (selectedReceiverAccount === null || selectedReceiverAccount === void 0 ? void 0 : selectedReceiverAccount.AccountType) === 'Futures';
  var selectedSenderAccount = accounts.find(function (account) {
    var _formObj$values$Sende;
    return account.AccountId === ((_formObj$values$Sende = formObj.values.SenderAccount) === null || _formObj$values$Sende === void 0 ? void 0 : _formObj$values$Sende.value);
  });
  var accountPositions = positions[selectedSenderAccount ? selectedSenderAccount.AccountId : initialSenderAccount.AccountId];
  var accountAssets = products.map(function (p) {
    var _accountPositions$p$P;
    var position = (_accountPositions$p$P = accountPositions[p.ProductId]) !== null && _accountPositions$p$P !== void 0 ? _accountPositions$p$P : {};
    var amount = Object.keys(position).length > 0 ? position.Amount - position.Hold : 0;
    var isEnabled = true;
    if (isMarginReceiver) {
      var matchingProduct = marginProducts.find(function (product) {
        return product.ProductId === p.ProductId;
      });
      isEnabled = matchingProduct ? !!matchingProduct.CollateralEnabled : false;
    } else if (isFuturesReceiver) {
      var _matchingProduct = futuresProducts === null || futuresProducts === void 0 ? void 0 : futuresProducts.data.find(function (product) {
        return product.ProductId === p.ProductId;
      });
      isEnabled = _matchingProduct ? !_matchingProduct.IsDisabled : false;
    }

    // Format label with balance for mobile native selects
    var formattedAmount = amount.toLocaleString(undefined, {
      minimumFractionDigits: p.DecimalPlaces,
      maximumFractionDigits: p.DecimalPlaces
    });
    var labelWithBalance = "".concat(p.Product, " ").concat(p.ProductFullName, " (").concat(formattedAmount, " ").concat(p.Product, ")");
    return {
      value: p.ProductId,
      label: labelWithBalance,
      simpleLabel: "".concat(p.Product, " ").concat(p.ProductFullName),
      amount: amount,
      ProductSymbol: p.Product,
      ProductId: p.ProductId,
      DecimalPlaces: p.DecimalPlaces,
      isEnabled: isEnabled
    };
  });
  var maxAmount;
  var isMarginSender = (selectedSenderAccount === null || selectedSenderAccount === void 0 ? void 0 : selectedSenderAccount.AccountType) === 'Margin';
  var selectedAsset = accountAssets.find(function (a) {
    var _formObj$values$Produ;
    return a.ProductId === Number((_formObj$values$Produ = formObj.values.Product) === null || _formObj$values$Produ === void 0 ? void 0 : _formObj$values$Produ.value);
  });
  if (isMarginSender) {
    var _formObj$values$Produ2;
    maxAmount = (0, _selectors.marginTransferAmountSelector)(state, (_formObj$values$Produ2 = formObj.values.Product) === null || _formObj$values$Produ2 === void 0 ? void 0 : _formObj$values$Produ2.value);
  } else {
    var productBalance = selectedAsset === null || selectedAsset === void 0 ? void 0 : selectedAsset.amount;
    maxAmount = Math.max(productBalance || 0, 0);
  }

  // Below filters out small balances based on decimal places for a given product
  // For example, for USD (2 decimal places), it checks if balance is greater than or equal to 0.01
  var assetsWithBalances = accountAssets.filter(function (asset) {
    return asset.amount >= Math.pow(10, -asset.DecimalPlaces);
  });
  return {
    formObj: formObj,
    assets: accountAssets,
    initialValues: {
      SenderAccount: {
        value: initialSenderAccount === null || initialSenderAccount === void 0 ? void 0 : initialSenderAccount.AccountId,
        label: initialSenderAccount === null || initialSenderAccount === void 0 ? void 0 : initialSenderAccount.AccountName
      },
      ReceiverAccount: {
        value: (_initialReceiverAccou = initialReceiverAccount) === null || _initialReceiverAccou === void 0 ? void 0 : _initialReceiverAccou.AccountId,
        label: (_initialReceiverAccou2 = initialReceiverAccount) === null || _initialReceiverAccou2 === void 0 ? void 0 : _initialReceiverAccou2.AccountName
      },
      Product: ownProps.defaultProductId ? accountAssets.find(function (p) {
        return p.ProductId === ownProps.defaultProductId;
      }) : accountAssets[0]
    },
    accounts: accounts,
    maxAmount: maxAmount,
    DecimalPlaces: (_formObj$values$Produ3 = formObj.values.Product) === null || _formObj$values$Produ3 === void 0 ? void 0 : _formObj$values$Produ3.DecimalPlaces,
    assetsWithBalances: assetsWithBalances,
    UsableMarginNotional: UsableMarginNotional,
    marginAccountId: marginAccount === null || marginAccount === void 0 ? void 0 : marginAccount.AccountId,
    isMarginSender: isMarginSender,
    isMarginReceiver: isMarginReceiver,
    isFuturesReceiver: isFuturesReceiver
  };
};
var Form = (0, _reduxForm.reduxForm)({
  form: 'marginTransferAssets',
  onSubmit: function onSubmit(payload, dispatch, _ref) {
    var _payload$SenderAccoun;
    var closeModal = _ref.closeModal;
    dispatch((0, _transferActions.transferFunds)({
      SenderAccountId: (_payload$SenderAccoun = payload.SenderAccount) === null || _payload$SenderAccoun === void 0 ? void 0 : _payload$SenderAccoun.value,
      ReceiverAccountId: payload.ReceiverAccount.value,
      ProductId: payload.Product.value,
      ProductSymbol: payload.Product.ProductSymbol,
      Amount: payload.Amount,
      Notes: 'assets transfer'
    }));
    closeModal();
  }
})(_MarginTransferAssetsFormComponent["default"]);
var MarginTransferAssetsFormContainer = (0, _reactRedux.connect)(mapStateToProps, {
  change: _reduxForm.change,
  untouch: _reduxForm.untouch,
  getMaxTransferAmount: _actions.getMaxTransferAmount
})(Form);
MarginTransferAssetsFormContainer.propTypes = {
  initialSenderId: _propTypes["default"].number,
  defaultProductId: _propTypes["default"].number
};
var _default = exports["default"] = MarginTransferAssetsFormContainer;